'use client';

import { c as _c } from "react/compiler-runtime";
import { useApprovedSet } from '@shared/utils/hooks/useApprovedSet';
import useUser from '@shared/utils/hooks/useUser';
import Modal, { ModalContent, ModalHeader } from '../HOC/Modal';
type Props = {
  closeHandler: () => void;
  onSelect: (bio: string) => void;
};
export const VerifiedBioChooser = t0 => {
  const $ = _c(11);
  const {
    closeHandler,
    onSelect
  } = t0;
  const {
    currentUser
  } = useUser();
  const set = useApprovedSet(currentUser.id);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h2>Choose Approved Bio</h2>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== closeHandler) {
    t2 = <ModalHeader closeHandler={closeHandler}>{t1}</ModalHeader>;
    $[1] = closeHandler;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== closeHandler || $[4] !== onSelect || $[5] !== set) {
    t3 = <ModalContent>{set === null ? <p className="text-sm text-textSecondary">Loading…</p> : set.approvedBios.length === 0 ? <div className="space-y-2"><p className="text-sm text-textSecondary">No approved bios on this device.</p><p className="text-xs text-textSecondary">Import a verification backup from Settings → User, or re-verify.</p></div> : <ul className="space-y-2">{set.approvedBios.map((bio, i) => <li key={i}><button onClick={() => {
            onSelect(bio);
            closeHandler();
          }} className="block w-full rounded-lg border border-ds-border-standard p-3 text-left text-sm text-textPrimary transition hover:border-primary">{bio}</button></li>)}</ul>}</ModalContent>;
    $[3] = closeHandler;
    $[4] = onSelect;
    $[5] = set;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== closeHandler || $[8] !== t2 || $[9] !== t3) {
    t4 = <Modal closeHandler={closeHandler} maxWidth={520}>{t2}{t3}</Modal>;
    $[7] = closeHandler;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export default VerifiedBioChooser;